import './imageUpload.scss';

import * as React from 'react'; 
import { dispatch } from '../../../utils/generalUtils';
import { OverlayTrigger, Tooltip } from 'react-bootstrap'; 
import { actions } from 'react-redux-form';
import * as PropTypes from 'prop-types';

export interface IImageUploadProps {
    label: string;
    buttonLabel?: string;
    multi?: boolean;
    defaultValue?;
}

export interface IImageUploadState {
    images: string[];
    oldUploads: string[];
}

export class ImageUpload extends React.Component<IImageUploadProps, IImageUploadState> {
    constructor(props: IImageUploadProps) {
        super(props);
        const { defaultValue } = this.props;
        this.state = { images: [], oldUploads: defaultValue };
    }

    get value() {
        return this.state.images;
    }

    handleImageDelete = (index) => {
        let imagesArray = this.state.images.filter((image, i) => i !== index);
        this.setState({
            images: imagesArray
        });
    }

    renderImages = () => {
        const { images } = this.state;
        return images.map((dataURL, index) => {
            return <div key={index} className="image">
                <i onClick={() => this.handleImageDelete(index)} className="fa fa-close"></i>
                <img src={dataURL} width="100px" height="100px" />
            </div>;
        });
    }

    handleImageUpload = (event) => {
        const files = event.target.files;
        let imagesArray = this.state.images.length > 0 ? this.state.images : [];
        let con = 0;
        const self = this;
        function readFile(e) {
            const name = new Date().getTime().toString();
            const imageBase64 = e.target.result;
            imagesArray.push(imageBase64);
            self.setState({
                images: imagesArray
            });
        }
        for (let i = 0; i < files.length; i++) {
            const file = files[i];
            const fileReader = new FileReader();
            fileReader.onload = readFile;
            fileReader.readAsDataURL(file);
        }
    }
    renderOldUploads = () => {
        //const { defaultValue } = this.props;
        return this.state.oldUploads.map((imageObj, index) => {
            let file = imageObj.split('/')[imageObj.split('/').length-1].split('.');
            return <div key={index} className="image">
                <i onClick={() => this.removeOldUpload(index, imageObj)} className="fa fa-close"></i>
                <img src={imageObj} width="100px" height="100px" />
            </div>;
        });

    }
    static contextTypes = {
        formModel: PropTypes.string
    };
    openFile = (imageObj) => {
        window.open(imageObj, "_blank");
    } 
    removeOldUpload = (index, image) => {
        const { context: { formModel } } = this;  
        var array = [...this.state.oldUploads]; // make a separate copy of the array
        var arrayIndex = array.indexOf(image) 
        if (arrayIndex !== -1) {
          array.splice(index, 1);
          this.setState({oldUploads: array}); 
        } 
        dispatch(actions.push(`${formModel}.deletedImages`, image )); 
    }
    render() {
        return <div className="image-upload" ref="images" >
            <div className="image-container-label" >{this.props.label}</div>
            <label htmlFor="imageFile" title="Click to select images" >
                {this.props.buttonLabel || 'Select Images'}
                <input multiple={this.props.multi} accept="image/gif, image/jpeg, image/png" 
                type="file" id="imageFile" onChange={this.handleImageUpload} />
            </label>
            <div className="display-image" >
                {this.renderImages()}
                {this.state.oldUploads && this.renderOldUploads()}
            </div>
        </div>;
    }
} 



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/reusableComponents/ImageUpload/index.tsx